import { useEffect, type ReactNode } from "react";

interface WorkspaceOverlayProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function WorkspaceOverlay({ open, onClose, title, subtitle, children }: WorkspaceOverlayProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="iw-overlay" onClick={onClose} role="presentation">
      <div
        className="iw-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="iw-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="iw-panel__toolbar">
          <div>
            <p className="iw-panel__eyebrow">Incident Workspace</p>
            <h2 id="iw-title" className="iw-panel__title">
              {title}
            </h2>
            {subtitle ? <p className="iw-panel__subtitle">{subtitle}</p> : null}
          </div>
          <button type="button" className="btn btn-ghost iw-panel__close" onClick={onClose} aria-label="Close workspace">
            ×
          </button>
        </header>
        <div className="iw-panel__body">{children}</div>
      </div>
    </div>
  );
}
